import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  btn: {
    fontWeight: "var(--fw-500)",
    padding: "12px 22px",
    fontSize: "14px",
    lineHeight: "1",
    borderRadius: "50rem",
    "&:hover": {
      "& .ar__icn": {
        animation: "org__pop 0.4s linear infinite",
      },
    },
    "&.disabled, &:disabled": {
      cursor: "not-allowed",
    },
    "&.btn-primary": {
      color: "rgb(var(--white))",
      border: "1px solid rgb(var(--primary))",
      backgroundColor: "rgb(var(--primary))",
      boxShadow: "0 0 10px rgb(var(--primary) / 0.04) !important",
      "&:not(:disabled, .disabled):hover, &:not(:disabled, .disabled):active, &:not(:disabled, .disabled).active, &:not(:disabled, .disabled):focus": {
        color: "rgb(var(--white))",
        border: "1px solid rgb(var(--primary))",
        backgroundColor: "rgb(var(--primary))",
      },
    },
    "&.btn-dark": {
      color: "rgb(var(--white))",
      border: "1px solid rgb(var(--dark))",
      backgroundColor: "rgb(var(--dark))",
      boxShadow: "0 0 10px rgb(var(--primary) / 0.04) !important",
      "&:not(:disabled, .disabled):hover, &:not(:disabled, .disabled):active, &:not(:disabled, .disabled).active, &:not(:disabled, .disabled):focus": {
        border: "1px solid rgb(var(--black))",
        backgroundColor: "rgb(var(--black))",
      },
    },
    "&.btn-light": {
      color: "rgb(var(--gray))",
      border: "1px solid rgb(var(--light))",
      backgroundColor: "rgb(var(--white))",
      boxShadow: "0 0 10px rgb(var(--dark) / 0.04) !important",
      "&:not(:disabled, .disabled):hover, &:not(:disabled, .disabled):active, &:not(:disabled, .disabled).active, &:not(:disabled, .disabled):focus": {
        color: "rgb(var(--dark))",
        border: "1px solid rgb(var(--dark))",
        backgroundColor: "#F5F7FA",
      },
    },
    "&.btn-outline-secondary": {
      color: "rgb(var(--gray))",
      borderColor: "rgb(var(--light))",
      backgroundColor: "rgb(var(--white))",
      boxShadow: "0 0 10px rgb(var(--dark) / 0.04) !important",
      "&:not(:disabled, .disabled):hover, &:not(:disabled, .disabled):active, &:not(:disabled, .disabled).active, &:not(:disabled, .disabled):focus": {
        color: "rgb(var(--dark))",
        backgroundColor: "rgb(var(--white))",
        borderColor: "rgb(var(--dark) / 0.20)",
      },
    },
    "&.btn-link": {
      color: "rgb(var(--dark))",
      border: "0",
      "&:not(:disabled, .disabled):hover, &:not(:disabled, .disabled):active, &:not(:disabled, .disabled).active, &:not(:disabled, .disabled):focus": {
        color: "rgb(var(--black))",
        textDecoration: "none",
      },
    },
  },
});
